<template>
  <div class="">
    <div class="head-title">产品模块</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            企业线索生成商机和签约合同时产品的选择，企业根据自身添加不同产品内容。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <nav class="navbar">
        <div class="navbar-l">
          <el-button
            icon="el-icon-plus"
            @click="(onSubmit = true), tianjia()"
            type="primary"
            >添加
          </el-button>
        </div>
        <div class="navbar-r">
          <el-input
            clearable
            placeholder="请输入产品名称搜索"
            style="width: 35.0rem; "
            prefix-icon="el-icon-search"
            v-model="input2"
            @change="rune()"
          >
          <el-button slot="append" @click="rune()" type="primary"
            >查询</el-button
          >
          </el-input>

        </div>
      </nav>
      <el-table
        :data="tableData"
        border
        v-loading="tableLoading"
        style="width: 100%; margin-top: 2.0rem"
        v-infinite-scroll="load"
      >
      <!---height="580"-->
        <el-table-column style="width:10%" prop="name" label="产品名称"></el-table-column>
        <el-table-column style="width:10%" prop="num" label="产品编码"></el-table-column>
        <el-table-column style="width:10%" prop="unit" label="单位"></el-table-column>
        <el-table-column style="width:10%" prop="price" label="标准价格"></el-table-column>
        <el-table-column style="width:10%" prop="status" label="是否上架"></el-table-column>
        <el-table-column
          prop="category_name"
          label="产品类别名称"
          style="width:10%"
        ></el-table-column>
        <el-table-column prop="description" label="产品描述" style="width:10%"></el-table-column>
        <el-table-column
          prop="createtime"
          label="添加时间"
          style="width:10%"
        ></el-table-column>
        <el-table-column
          prop="updatetime"
          label="修改时间"
          style="width:10%"
        ></el-table-column>
        <el-table-column label="操作"   fixed="right" width="200" >
          <template slot-scope="scope">
            <el-button
              @click="
                (onSubmitn = true),
                  bianji(
                    scope.row.id,
                    scope.row.name,
                    scope.row.num,
                    scope.row.unit,
                    scope.row.price,
                    scope.row.status,
                    scope.row.category_id,
                    scope.row.description,
                    scope.row.category_name
                  )
              "
              type="text"
              size="mini"
              >编辑</el-button
            >
            <el-button
              @click="handleClickdf(scope.row.id)"
              type="text"
              size="mini"
              style="color:#f00000 !important"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging">
        <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          :page-sizes="[10,20,50,100]"
          :auto-scroll="false"
          @pagination="userTable"
        />
      </div>
      <el-dialog  title="添加产品模块" center :visible.sync="onSubmit" width="30%">
        <el-form ref="form" :model="form" :rules="rules" label-width="8.0rem">
          <el-form-item label="名称" prop="name">
            <el-input clearable v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="编码" prop="num">
            <el-input clearable v-model="form.num"></el-input>
          </el-form-item>
          <el-form-item label="单位" prop="unit">
            <el-input clearable v-model="form.unit"></el-input>
          </el-form-item>
          <el-form-item label="标准价格" prop="price">
            <el-input clearable v-model="form.price"></el-input>
          </el-form-item>
          <el-form-item label="是否上架" prop="status">
            <el-radio-group v-model="form.status">
              <el-radio label="上架"></el-radio>
              <el-radio label="下架"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="产品类别" prop="nlist">
            <div>
              <el-button @click="onSubmits = true">类别</el-button>
            </div>
            <div style="margin-top: .8rem">
              <el-tag v-if="nlist.length">{{ nlist[0].label }}</el-tag>
            </div>
          </el-form-item>
          <el-form-item label="产品描述" prop="description">
            <el-input clearable v-model="form.description"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onSubmit = false">取 消</el-button>
          <el-button type="primary" @click="numoo()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog  title="编辑" center :visible.sync="onSubmitn" width="30%">
        <el-form ref="form"  :rules="rules" :model="form" label-width="8.0rem">
          <el-form-item label="名称" prop="bname">
            <el-input clearable v-model="form.bname"></el-input>
          </el-form-item>
          <el-form-item label="编码" prop="bnum">
            <el-input clearable v-model="form.bnum"></el-input>
          </el-form-item>
          <el-form-item label="单位" prop="bunit">
            <el-input clearable v-model="form.bunit"></el-input>
          </el-form-item>
          <el-form-item label="标准价格" prop="bprice">
            <el-input clearable v-model="form.bprice"></el-input>
          </el-form-item>
          <el-form-item label="是否上架" prop="bstatus">
            <el-radio-group v-model="form.bstatus">
              <el-radio label="上架"></el-radio>
              <el-radio label="下架"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="产品类别" prop="nlist">
            <div>
              <el-button @click="onSubmits = true">类别</el-button>
            </div>
            <div style="margin-top: .8rem">
              <el-tag v-if="nlist.length">{{ nlist[0].label }}</el-tag>
            </div>
          </el-form-item>
          <el-form-item label="产品描述" prop="bdescription">
            <el-input clearable v-model="form.bdescription"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onSubmitn = false">取 消</el-button>
          <el-button type="primary" @click="numoon()">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="类别选择" center :visible.sync="onSubmits" width="30%">
        <el-radio-group
          v-model="single"
          v-for="(item, index) in tableData_a"
          :key="index"
          @change="changeC"
        >
          <el-radio :label="item.id" style="margin-left: 2.0rem">{{
            item.label
          }}</el-radio>
        </el-radio-group>
        <span slot="footer" class="dialog-footer">
          <el-button @click="(onSubmits = false),quxiao()">取 消</el-button>
          <el-button type="primary" @click="(onSubmits = false), sbom()"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  inject: ["reload"],
  name: "monitoring",
  data() {
    return {
      title: {},
      tooken: "",
      tableData: [],
      input2: "",
      onSubmit: false,
      onSubmitn: false,
      onSubmits: false,
      aonSubmits: false,
      tableData_a: [],
      multipleSelection: [],
      value1: true,
      form: {
        //   添加
        name: "", //名称
        num: "", //编码
        unit: "", //单位
        price: "", //标准价格
        status: "上架", //是否上架
        category_id: "", //产品类别
        description: "", //产品描述
        bname: "", //名称
        bnum: "", //编码
        bunit: "", //单位
        bprice: "", //标准价格
        bstatus: "", //是否上架
        bcategory_id: "", //产品类别
        bdescription: "", //产品描述
      },
      ele: "",
      yeshu: 1,
      bianjile: "",
      lock: true,
      nlist: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      duihao: [],
      i: 0,
      single: "",
      rules: {
          name: [
            { required: true, message:'请输入产品名称',  trigger: 'blur' },
          ],
          bname: [
            { required: true,   trigger: 'blur' },

          ],
          nlist: [
            { required: true, trigger: 'change' }
          ],},
      total:0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      tableLoading: true,
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.userTable();
    this.tianjia();
  },
  methods: {
    changeC() {
      this.nlist = this.tableData_a.filter((item) => {
        if (this.single == item.id) {
          return item;
        }
      });
    },
    quxiao(){
      this.nlist =[]
    },
    sbom() {
      this.yeshu = 1;
    },
    //  页数
    load() {
      this.yeshu += 1;
      if (this.lock == true) {
        this.axios
          .post(
            "/crm/CustomerLevel/getCustomerLevel",
            qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              phone: this.tooken.phone,
              page: this.yeshu,
              name: this.input2,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
            if (res.data.code == 1) {
              this.lock = true;
            } else if (res.data.code == 0) {
              this.lock = false;
            }
            res.data.data.forEach((item) => {
              this.tableData.push(item);
            });
          })
          .catch(function (err) {});
      } else {
        return;
      }
    },
    userTable() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Product/getProductList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.input2,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableLoading = false;
          this.tableData = res.data.data;
          this.total = res.data.count
        })
        .catch(function (err) {});
    },
    rune() {
      this.yeshu = 1;
      this.userTable();
    },
    tianjia() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/ProductCategory/getCategoryList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },

    handleSelectionChange(val) {
      this.yeshu = 1;
      this.multipleSelection = val;
    },
    bianji(e, o, q, w, r, t, y, u, name) {
      this.nlist = [
        {
          label: name,
          id: y,
        },
      ];
      this.yeshu = 1;
      (this.form.bname = o), //名称
        (this.form.bnum = q), //编码
        (this.form.bunit = w), //单位
        (this.form.bprice = r), //标准价格
        (this.form.bstatus = t), //是否上架
        (this.form.bcategory_id = y), //产品类别
        (this.form.bdescription = u), //产品描述
        (this.ele = e);
      this.axios
        .post(
          "/crm/ProductCategory/getCategoryList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    // 修改
    numoon() {
      if(this.form.bname.trim()==""){
        this.$message.error("产品名称不能为空");
        return;
      }
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Product/editProduct",
          qs.stringify({
            id: this.ele,
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.form.bname,
            num: this.form.bnum, //编码
            unit: this.form.bunit, //单位
            price: this.form.bprice, //标准价格
            status: this.form.bstatus, //是否上架
            category_id: this.nlist[0].id, //产品类别
            description: this.form.bdescription, //产品描述
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitn = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.reload();
          } else if (res.data.code == 0) {
            this.onSubmitn = true;
            this.$message.error(res.data.msg);
          }
          // this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
        })
        .catch(function (err) {});
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    // 添加
    numoo() {
      if (this.nlist.length == 0) {
        this.$message.error("请选择产品类别");
        return;
      }
      if(this.form.name.trim()==""){
        this.$message.error("产品名称不能为空");
        return;
      }
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Product/addProduct",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.form.name,
            num: this.form.num, //编码
            unit: this.form.unit, //单位
            price: this.form.price, //标准价格
            status: this.form.status, //是否上架
            category_id: this.nlist[0].id, //产品类别
            description: this.form.description, //产品描述
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.reload();
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
          // this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
        })
        .catch(function (err) {});
    },
    // 移除
    handleClickdf(e, o) {
      this.yeshu = 1;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/Product/delProduct",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                id: e,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
              this.userTable();
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.tableData_a = res.data.data;
            })
            .catch(function (err) {});
        })
        .catch(() => {
          this.$message({
            message: "已取消删除",
            type: "info",
          });
        });
    },
  },
};
</script>
<style scoped>
.hello {
  width: 100%;
  height: 100%;
  padding: 2.0rem;
  overflow: hidden;
  overflow-y: auto;
}
nav {
  width: 100%;
}
.shij {
  display: inline-block;
  margin-right: 2.4rem;
}
.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  -webkit-box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
}
.el-button--text{padding-left:.0rem !important;}
</style>
